import { render, staticRenderFns } from "./CategoryProps.vue?vue&type=template&id=a7fe1f4a&scoped=true"
import script from "./CategoryProps.vue?vue&type=script&lang=js"
export * from "./CategoryProps.vue?vue&type=script&lang=js"
import style0 from "./CategoryProps.vue?vue&type=style&index=0&id=a7fe1f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fe1f4a",
  null
  
)

export default component.exports